import request from '@/plugin/axios'

/**
 * 保存查询条件
 */
export function insertUserSelect (obj) {
  return request({
    url: '/basic/basicUser/insertUserSelect',
    method: 'post',
    data: obj
  })
}
/**
 * 删除查询条件
 */
export function delUserSelect (id) {
  return request({
    url: '/basic/basicUser/' + id,
    method: 'delete'
  })
}
/**
 * 查询当前用户当前菜单查询配置
 */
export function getUserSelectList (obj) {
  return request({
    url: '/basic/basicUser/getUserSelectList',
    method: 'post',
    data: obj
  })
}
